import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from './Icons';

const NotFound = ({ type = 'page' }) => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    const getMessage = () => {
        switch (type) {
            case 'blog':
                return {
                    title: "Blog Post Not Found",
                    description: "The blog post you're looking for doesn't exist or has been moved.",
                    suggestion: "Check out our latest blog posts instead."
                };
            default:
                return {
                    title: "Page Not Found",
                    description: "The page you're looking for doesn't exist.",
                    suggestion: "Return to the main portfolio."
                };
        }
    };

    const message = getMessage();

    return (
        <div className="min-h-screen bg-cream-100 flex items-center justify-center px-4">
            <div className="text-center max-w-md">
                <div className="font-serif text-8xl font-medium text-coral-500/30 mb-2 select-none">404</div>

                <h1 className="font-serif text-2xl md:text-3xl font-medium text-charcoal-900 mb-4">
                    {message.title}
                </h1>

                <p className="text-charcoal-600 mb-2">
                    {message.description}
                </p>

                <p className="text-charcoal-500 text-sm mb-8">
                    {message.suggestion}
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                    <button
                        onClick={handleGoHome}
                        className="btn-primary w-full sm:w-auto"
                    >
                        <ArrowLeftIcon className="w-4 h-4" />
                        <span>Go to Portfolio</span>
                    </button>

                    {type === 'blog' && (
                        <button
                            onClick={() => navigate('/#blog')}
                            className="btn-secondary w-full sm:w-auto"
                        >
                            <span>View All Blogs</span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NotFound;
